/**
 * @fileOverview This file contains the implementation of the Permission component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import variables from '../../scss/_variables.scss';
//#endregion

const Permission = ({ permission, onPermissionChange }) => {
  const [checked, setChecked] = useState(permission.has_permission === 1);

  const handleChange = (event) => {
    const newCheckedState = event.target.checked;
    setChecked(newCheckedState);
    onPermissionChange(permission.permission_id, newCheckedState);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={handleChange} />}
        label={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{permission.permission_name}</span>
            {permission.is_monetizable === 1 && (
              <FontAwesomeIcon
                icon={faDollarSign}
                style={{ marginLeft: '8px', color: variables.redDabi }}
              />
            )}
          </Box>
        }
      />
      <Typography variant='caption' sx={{ ml: 2 }}>
        {permission.permission_description || 'Descripción del permiso'}
      </Typography>
    </Box>
  );
};

export default Permission;
